import { Component, Prop, h, State, Host } from '@stencil/core';
import '../header-component/header-component';
import '../loader-component/loader-component'


/**
#### Sample screen shot
![image info](https://infonet.nyp.org/webc/PublishingImages/tiles-component.PNG)

#### Content Type
nypwebc_ct_tiles
*/


@Component({
  tag: 'tiles-component',
  styleUrl: 'tiles-component.css',
  scoped: true
})
export class TilesComponent {

  /**
   *Required - Unique ID.
   */
  @Prop() componentid: string = "comp-id";

  /**
  *Required - List Name.
  */
  @Prop() listname: string = "ListName";

  /**
  *Required - Relative to the root site. no trailing slash. for ex: /hr/pm
  */
  @Prop() webpath: string = "/";

  /**
  *Required - if header attribute is true
  */
  @Prop() sectiontitle: string = "Section Title";

  /**
  *Required - if header attribute is true
  */
  @Prop() titleiconurl: string = "";

  /**
  *Optional - To show/hide header. default is true
  */
  @Prop() header: boolean = true;

  /**
 *Optional - vertical scroll bar
 */
  @Prop() verticalscroll: boolean = false;

  /**
 *Optional - vertical scroll bar height
 */
  @Prop() verticalscrollheight: number = 200;


  /**
*Optional - direction of the tile (vertical or horizantal). default is vertical
*/
  @Prop() direction: string = "vertical"

  /**
*Optional - image only on the card?
*/
  @Prop() imageonly: boolean = false

  /**
*Optional - number of columns?
*/
  @Prop() itemperrow: number = 1


  /**
*Optional - card border true or false?
*/
  @Prop() cardborder: boolean = false


  /**
*Optional - header background color
*/
  @Prop() headerbgcolor: string = "white"

  /**
  *Optional -header text color
  */
  @Prop() headertextcolor: string = "black"

  /**
  *Optional -bodycolor text color
  */
  @Prop() sectionbodycolor: string = "white"

  /**
  *Optional -header border bottom css
  */
  @Prop() headerborderbottom: string = "1px solid #CE2127"

  /**
 *Optional - To show see all link
 */
  @Prop() seeall: boolean = false;
  /**
 *Optional - see All link
 */
  @Prop() seeallurl: string = "";

  /**
*Optional - see All link Title
*/
  @Prop() seealltitle: string = "See All";
  /**
*Optional - is it SP Online site
*/
  @Prop() online: boolean = false;

  /**
   *Required - site url if its sp online site
   */
  @Prop() siteurl: string = "";

  /**
 *optional - style
 */
  @Prop() styleversion: string = "v1";


  @State() items: []
  @State() isLoading: boolean = true;

  componentDidLoad() {
    // const siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl;
    // let siteUrl: string = "";

    // if (this.online) {
    //   siteUrl = this.siteurl + this.webpath
    // }
    // else {
    //   siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl + this.webpath;
    // }

    let siteUrl: string = "";
    if ((window as any)._spPageContextInfo != null) {
      siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl + this.webpath;
    }
    else {
      let domain = new URL(window.location.href)
      siteUrl = domain.origin + this.webpath
    }

    const filter = "nypwebc_Active eq 1";
    return fetch(siteUrl + "/_api/web/lists/getbytitle('" + this.listname + "')/items?$select=ID,Title,nypwebc_ItemOrder,nypwebc_Url,nypwebc_ImageUrl&$filter=" + filter + "&$orderby=nypwebc_ItemOrder&", { headers: { "Accept": "application/json; odata=verbose" } })

      .then(response => response.json())
      .then(data => {
        this.items = data.d.results;
        this.isLoading = false;
      });
  }

  getContentsV2 = () => {


    const contentsArray = []
    this.items.forEach((item: any) => {

      contentsArray.push(
        <div class="col">
          <a href={item.nypwebc_Url}  target= "_blank"  data-interception="off">
            <div class="sect">
              <img src={item.nypwebc_ImageUrl} alt={item.Title} class="img-fluid w-100 d-block mx-auto" />
              <div class="content">
                <p class="text-center">{item.Title}</p>
              </div>
            </div>
          </a>
        </div>

      )


    });

    return contentsArray
  }

  getContentsV3 = () => {


    const contentsArray = []
    this.items.forEach((item: any) => {

      contentsArray.push(

        <div class="grid-item"><a href={item.nypwebc_Url} target= "_blank"  data-interception="off">
          <img src={item.nypwebc_ImageUrl} alt={item.Title} />
        </a></div>


        // <div class="col">
        //   <a href={item.nypwebc_Url} >
        //     <div class="sect">
        //       <img src={item.nypwebc_ImageUrl} alt={item.Title} class="img-fluid w-100 d-block mx-auto" />
        //       <div class="content">
        //         <p class="text-center">{item.Title}</p>
        //       </div>
        //     </div>
        //   </a>
        // </div>

      )


    });

    return contentsArray
  }

  getContents = () => {
    const contentsArray = []
    this.items.forEach((item: any) => {


      let cardborder = {}
      if (!this.cardborder) {
        cardborder = {
          border: "none"
        }
      }
      else {
        cardborder = {
          border: "1px solid rgba(0,0,0,.125)"
        }

      }

      if (this.imageonly) {

        if (this.direction === "horizantal") {

          contentsArray.push(
            <div class="col">
              <a href={item.nypwebc_Url}  target= "_blank"  data-interception="off">
                <div class="card h-100" style={cardborder}>
                  <img title={item.Title} class="img-fluid w-100 d-block mx-auto" src={item.nypwebc_ImageUrl} alt={item.Title} />
                </div>
              </a>
            </div>
          )
        }
        else {

          contentsArray.push(

            <div class="row" style={{ marginBottom: "25px" }}>
              <div class="col">
                <a href={item.nypwebc_Url} target= "_blank"  data-interception="off" >
                  <div class="card h-100" style={cardborder} >
                    <img title={item.Title} class="card-img-top" src={item.nypwebc_ImageUrl} alt={item.Title} />
                  </div>
                </a>
              </div>
            </div>
          )

        }
      }
      else {

        if (this.direction === "horizantal") {

          contentsArray.push(

            <div class="col">
              <a href={item.nypwebc_Url} target= "_blank"  data-interception="off" >
                <div class="card h-100" style={cardborder}>
                  <img title={item.Title} class="card-img-top" src={item.nypwebc_ImageUrl} alt={item.Title} />
                  <div class="card-body">
                    <h5 class="card-title" >{item.Title}</h5>
                  </div>
                </div>
              </a>
            </div>


          )
        }
        else {

          contentsArray.push(

            <div class="row" style={{ marginBottom: "25px" }}>
              <div class="col">
                <a href={item.nypwebc_Url} target= "_blank"  data-interception="off" >
                  <div class="card h-100" style={cardborder}>
                    <img title={item.Title} class="card-img-top" src={item.nypwebc_ImageUrl} alt={item.Title} />
                    <div class="card-body">
                      <h5 class="card-title" >{item.Title}</h5>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          )

        }
      }
    })
    return contentsArray
  }


  render() {

    let style = {}
    let styleWithHeader = {}
    let parentstyle = {}
    if (this.verticalscroll) {
      style = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
      }
      styleWithHeader = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
      }

      parentstyle = {
        minHeight: (this.verticalscrollheight + 20) + "px",
        backgroundColor: this.sectionbodycolor,
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        paddingBottom: "10px"
      }
    }
    else {
      style = {
      }
      parentstyle = {
        backgroundColor: this.sectionbodycolor,
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        paddingBottom: "10px"
      }
    }

    let itemperrowclass = "row justify-content-center row-cols-md-" + this.itemperrow + " g-3"
    return (
      this.isLoading ? <loader-component />
        :
        this.header && this.items.length > 0 ?
        //  this.styleversion === "v3" ?

        //   <div id={this.componentid}>
        //     <header-component sectiontitle={this.sectiontitle} titleiconurl={this.titleiconurl} seeall={this.seeall} seealltitle={this.seealltitle} seeallurl={this.seeallurl} headerbgcolor={this.headerbgcolor} headertextcolor={this.headertextcolor} headerborderbottom={this.headerborderbottom} />

        //     <div class="row gx-0 justify-content-center" style={parentstyle} >
        //       <div style={styleWithHeader} >


        //         <div class="top-container">

        //           {this.getContentsV3()}
        //         </div>
        //       </div>
        //     </div>
        //   </div>
        //   :

          <div id={this.componentid}>
            <header-component sectiontitle={this.sectiontitle} titleiconurl={this.titleiconurl} seeall={this.seeall} seealltitle={this.seealltitle} seeallurl={this.seeallurl} headerbgcolor={this.headerbgcolor} headertextcolor={this.headertextcolor} headerborderbottom={this.headerborderbottom} />
            <div class="row gx-0 justify-content-center" style={parentstyle} >
              <div style={styleWithHeader} class={itemperrowclass} >
                {this.styleversion === "v1" ? this.getContents() : this.getContentsV2()}

              </div>
            </div>
          </div>
          :
          <div id={this.componentid} class="row gx-0 justify-content-center" style={parentstyle} >
            <div style={style} class={itemperrowclass} >
              {this.styleversion === "v1" ? this.getContents() : this.getContentsV2()}

            </div>
          </div>
    )

  }
}
